import { css } from "lit";

export const style = css`
  .background {
    display: block;
    width: 130px;
    padding: var(--sds-size-space-150);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    box-shadow: 0 var(--sds-size-space-100) var(--sds-size-space-100) 0 var(--sds-color-black-300);
    text-decoration: none;

    & .image {
      position: relative;
      width: 100%;
      aspect-ratio: 1.2/1;

      &::after {
        content: "";
        background: linear-gradient(transparent 0%, var(--sds-color-background-default-default) 100%);
        position: absolute;
        z-index: 1;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
      }

      & img {
        width: 100%;
        border-radius: var(--sds-size-radius-200);
        aspect-ratio: 1.2/1;
        object-fit: cover;
        object-position: center 40%;
      }
    }

    & .handle {
      display: flex;
      padding: var(--sds-size-space-200) var(--sds-size-space-300);
      margin: var(--sds-size-space-150);
      justify-content: space-between;
      align-items: center;
      flex-shrink: 0;
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
      border-radius: var(--sds-size-radius-200);
      background: var(--sds-color-background-default-secondary);

      color: var(--sds-color-text-default-secondary);

      /* Single Line/Body Small */
      font-family: var(--sds-typography-family-body);
      font-size: var(--sds-typography-body-size-small);
      font-style: normal;
      font-weight: var(--sds-typography-weight-regular);
      line-height: 100%; /* 12px */
    }
  }
`;
